import { render, staticRenderFns } from "./PreviewProductListModal.vue?vue&type=template&id=621ca3f2&scoped=true&"
import script from "./PreviewProductListModal.vue?vue&type=script&lang=js&"
export * from "./PreviewProductListModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProductListModal.vue?vue&type=style&index=0&id=621ca3f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ca3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621ca3f2')) {
      api.createRecord('621ca3f2', component.options)
    } else {
      api.reload('621ca3f2', component.options)
    }
    module.hot.accept("./PreviewProductListModal.vue?vue&type=template&id=621ca3f2&scoped=true&", function () {
      api.rerender('621ca3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/PreviewProductListModal.vue"
export default component.exports